<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../../../core/config/constants.js'
import BusinessBanner from './BusinessBanner.vue'

defineEmits(['scroll-to-stats'])
</script>

<template>
  <!-- Mobile Phone Frame (visible only on mobile) -->
  <div class="mobile-phone-wrapper">
    <!-- Phone frame (animated) -->
    <div class="mobile-phone-frame">
      <div class="mobile-phone-notch">
        <div class="notch-camera"></div>
      </div>
      <div class="mobile-phone-screen"></div>
      <div class="mobile-phone-home-indicator"></div>
    </div>

    <!-- Content overlay (static, above the phone) -->
    <div class="mobile-content-overlay">
      <div class="hero-content">
        <div class="hero-badge-wrapper">
          <div class="hero-badge">
            <span class="badge-dot"></span>
            <span>מובילים בייבוא מזון בישראל</span>
          </div>
          <div class="hero-sub-badge">
            <span class="sub-badge-dot"></span>
            <span>ועכשיו גם פארם</span>
          </div>
        </div>
        <h1 class="hero-title">
          <span class="title-line">הבחירה של</span>
          <span class="title-highlight">הקמעונאים</span>
        </h1>
        <p class="hero-subtitle">
          חברת יבוא ושיווק מזון מובילה, עם אלפי לקוחות בכל רחבי הארץ. מותגים מובילים, מחירים
          תחרותיים, ומשלוחים לכל נקודה בישראל.
        </p>
        <div class="hero-actions">
          <RouterLink :to="{ name: ROUTES.CATALOG }" class="btn-primary-lg">
            <span>הקטלוג שלנו</span>
          </RouterLink>
          <button @click="$emit('scroll-to-stats')" class="btn-secondary-lg">
            <span>עוד עלינו</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Business Banner - Mobile (floating over phone) -->
    <BusinessBanner variant="mobile" />

    <!-- Floating elements around mobile phone -->
    <div class="mobile-floating-cart mobile-cart-1">
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill="white" />
        <circle cx="20" cy="20" r="18" fill="#FEF3C7" />
        <g transform="translate(10, 8)">
          <circle cx="6" cy="20" r="2.5" fill="#D97706" />
          <circle cx="16" cy="20" r="2.5" fill="#D97706" />
          <path
            d="M0 2 H3 L6 14 H18 L21 6 H8"
            stroke="#D97706"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"
          />
        </g>
      </svg>
    </div>
    <div class="mobile-floating-cart mobile-cart-2">
      <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="18" r="18" fill="white" />
        <circle cx="18" cy="18" r="16" fill="#FFFBEB" />
        <g transform="translate(9, 7)">
          <rect x="2" y="5" width="14" height="10" rx="2" fill="#F59E0B" />
          <path
            d="M5 5 V3 C5 1.5 6.5 0 9 0 C11.5 0 13 1.5 13 3 V5"
            stroke="#D97706"
            stroke-width="1.5"
            fill="none"
          />
        </g>
      </svg>
    </div>
    <div class="mobile-floating-cart mobile-cart-3">
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="white" />
        <circle cx="16" cy="16" r="14" fill="#FEF3C7" />
        <text x="16" y="20" text-anchor="middle" fill="#D97706" font-size="12" font-weight="bold">
          %
        </text>
      </svg>
    </div>

    <!-- Mobile sparkles -->
    <div class="mobile-sparkle mobile-sparkle-1"></div>
    <div class="mobile-sparkle mobile-sparkle-2"></div>
    <div class="mobile-sparkle mobile-sparkle-3"></div>
    <div class="mobile-sparkle mobile-sparkle-4"></div>
  </div>
</template>

<style src="../styles/hero-shared.css" scoped></style>
<style src="../styles/hero-mobile.css" scoped></style>
